import { render, staticRenderFns } from "./IntroSlideTitle.vue?vue&type=template&id=c01d413c&scoped=true&"
import script from "./IntroSlideTitle.vue?vue&type=script&lang=js&"
export * from "./IntroSlideTitle.vue?vue&type=script&lang=js&"
import style0 from "./IntroSlideTitle.vue?vue&type=style&index=0&id=c01d413c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d413c",
  null
  
)

export default component.exports